import {
  jb_search_input_css_default
} from "./chunk.MAVIIEAX.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.YSL2HSIS.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-search-input/jb-search-input.ts
var JbSearchInput = class extends FormElement(r) {
  constructor() {
    super(...arguments);
    this.suggestMode = "auto-suggest";
    this._searchResults = void 0;
    this._selectionIndex = 0;
    this._suggestions = void 0;
  }
  focusSearchInput() {
    this._inputElement?.focus();
  }
  _clearInput() {
    if (!this._inputElement) {
      return;
    }
    this._inputElement.value = "";
    this._inputElement.focus();
    this._handleInput();
  }
  _getSuggestMode() {
    if (this.suggestMode === "find-as-you-type") {
      return this.suggestMode;
    }
    return "auto-suggest";
  }
  _goToResult($target) {
    window.open($target.url, "_self");
  }
  _handleInput() {
    if (!this._inputElement || !this.autoSuggestUrl || !this.suggestMode) {
      return;
    }
    this.value = this._inputElement.value;
    const term = this._inputElement.value.trim();
    if (term.length <= 2) {
      this._suggestions = void 0;
      return;
    }
    const url = this.autoSuggestUrl.replace("term", encodeURI(term));
    fetch(url).then((response) => response.json()).then((data) => {
      this._selectionIndex = 0;
      if (this._getSuggestMode() === "auto-suggest") {
        this._suggestions = data.suggestions;
      } else {
        this._searchResults = data.suggestions;
        this._suggestions = Object.keys(data.suggestions[0]);
      }
    });
  }
  _handleKeydown(e2) {
    setTimeout(() => {
      this.value = this._inputElement?.value;
    });
    if (e2.key === "Escape" && this._suggestions?.length) {
      e2.preventDefault();
      this._suggestions = void 0;
      return;
    }
    if (e2.code === "Space" && this._selectionIndex > 0) {
      e2.preventDefault();
      this._inputElement.value = this._suggestions[this._selectionIndex - 1];
      this.value = this._inputElement?.value;
      return;
    }
    if (e2.key === "Enter" && this._inputElement?.value) {
      e2.preventDefault();
      if (this._selectionIndex > 0) {
        this._inputElement.value = this._suggestions[this._selectionIndex - 1];
        this.value = this._inputElement?.value;
      }
      this._submit();
      return;
    }
    if ((e2.key === "ArrowDown" || e2.key === "ArrowUp") && this._suggestions?.length) {
      if (e2.key === "ArrowDown") {
        this._selectionIndex = Math.min(this._selectionIndex + 1, this._suggestions?.length || 0);
      }
      if (e2.key === "ArrowUp") {
        this._selectionIndex = Math.max(this._selectionIndex - 1, 0);
      }
      e2.preventDefault();
    }
  }
  _renderSuggestions(renderMode) {
    return this._suggestions?.map((suggestion) => {
      if (!this._inputElement) {
        return "";
      }
      const li = document.createElement("li");
      if (this._selectionIndex === 0) {
        const regEx = new RegExp(this._inputElement.value, "gi");
        li.innerHTML = suggestion.replace(regEx, "<span>$&</span>");
      } else if (this._suggestions[this._selectionIndex - 1] === suggestion) {
        const regEx = new RegExp(this._inputElement.value, "gi");
        li.innerHTML = suggestion.replace(regEx, "<span>$&</span>");
        li.classList.add("active");
      } else {
        const regEx = new RegExp(this._inputElement.value, "gi");
        li.innerHTML = suggestion.replace(regEx, "<span>$&</span>");
      }
      li.addEventListener("click", () => {
        if (this._inputElement) {
          this._inputElement.value = suggestion;
        }
        if (renderMode === "auto-suggest") {
          this._submit();
        } else {
          if (suggestion && this._searchResults) {
            this._goToResult(this._searchResults[0][suggestion]);
          }
        }
      });
      return ke`${li}`;
    });
  }
  _submit() {
    if (!this._inputElement || !this._inputElement.value) {
      return;
    }
    this._suggestions = void 0;
    this.dispatchEvent(
      new CustomEvent("jb-search-input:submit", {
        detail: { value: this._inputElement?.value },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <section>
        <div>
          <input
            @input=${this._handleInput}
            @keydown=${this._handleKeydown}
            .placeholder=${this.placeholder}
            type="text"
            .value=${this.value}
            aria-label="${this.ariaLabels?.input ?? D}"
          />
        </div>
        ${this.value !== "" ? ke`<button
              aria-label="${this.ariaLabels?.clear ?? D}"
              @click=${this._clearInput}
              @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.code === "Space") {
        evt.preventDefault();
        this._clearInput();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      }
    }}
            >
              <jb-search-clear-icon></jb-search-clear-icon>
            </button>` : ke`<div></div>`}

        <button
          aria-label="${this.ariaLabels?.search ?? D}"
          @click=${this._submit}
          @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.code === "Space") {
        evt.preventDefault();
        this._submit();
      }
    }}
        >
          <jb-search-icon></jb-search-icon>
        </button>
      </section>
      ${this._suggestions?.length ? ke` <ul aria-live="polite">
            ${this._renderSuggestions(`${this.suggestMode}`)}
          </ul>` : D}
    `;
  }
};
JbSearchInput.styles = [reset_css_default, jb_search_input_css_default];
__decorateClass([
  n({ type: Object })
], JbSearchInput.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbSearchInput.prototype, "autoSuggestUrl", 2);
__decorateClass([
  n()
], JbSearchInput.prototype, "placeholder", 2);
__decorateClass([
  n()
], JbSearchInput.prototype, "suggestMode", 2);
__decorateClass([
  r2(),
  e("input")
], JbSearchInput.prototype, "_inputElement", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_searchResults", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_selectionIndex", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_suggestions", 2);
JbSearchInput = __decorateClass([
  customElement("jb-search-input")
], JbSearchInput);

export {
  JbSearchInput
};
